// Mirai functions
window.mirai = window.mirai || {};

mirai.init = function () {
  mirai.splashPage();
  mirai.headerCarousel();
  mirai.mainNavInit();
  mirai.searchModal();
  mirai.languageModal();
  mirai.instabewbsModal();
  mirai.checkoutNotesModal();
  mirai.promotion();
  mirai.recentlyViewedProducts.showRecentlyViewed( { howManyToShow: 12 } );
  mirai.relatedProducts.showRelatedProducts( { howManyToShow: 12 } );
  mirai.instabewbs();
  mirai.releaseCalendar();
  mirai.productWhistleblower();
  mirai.checkoutQuestionnaire();
  mirai.footerSplashImage();
  mirai.garageIntroTruncate();
  mirai.collapsibleStickySidebarInit();
  mirai.variantGridDrawers();
  mirai.variantGridLightbox();
  mirai.productArticle();
  mirai.productArticleSidebar();
  mirai.randomiseGridItemImages();
};

// Helpers

mirai.scrollToY = function (y, duration, element) {
  duration = duration === undefined ? 0 : duration;
  element = element === undefined ? document.scrollingElement : element;

  if (duration === 0) {
    document.scrollingElement.scrollTop = 0;
    return;
  }

  // cancel if already on target position
  if (element.scrollTop === y) return;

  var cosParameter = (element.scrollTop - y) / 2;
  let scrollCount = 0, oldTimestamp = null;

  function step(newTimestamp) {
    if (oldTimestamp !== null) {
      // if duration is 0 scrollCount will be Infinity
      scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
      if (scrollCount >= Math.PI) return element.scrollTop = y;
      element.scrollTop = cosParameter + y + cosParameter * Math.cos(scrollCount);
    }
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
};

mirai.scrollToTop = function (duration) {
  duration = duration === undefined ? 0 : duration;

  mirai.scrollToY(0, duration, document.scrollingElement);
};

mirai.scrollToId = function (id, duration, additionalOffset) {
  duration = duration === undefined ? 0 : duration;
  additionalOffset = additionalOffset === undefined ? 0 : additionalOffset;

  var offset = Math.round(document.getElementById(id).getBoundingClientRect().top);
  mirai.scrollToY(document.scrollingElement.scrollTop + offset + additionalOffset, duration);
};

mirai.scrollToElement = function (element, duration, additionalOffset) {
  duration = duration === undefined ? 0 : duration;
  additionalOffset = additionalOffset === undefined ? 0 : additionalOffset;

  var offset = Math.round(element.getBoundingClientRect().top);
  mirai.scrollToY(document.scrollingElement.scrollTop + offset + additionalOffset, duration);
};

mirai.debounce = function (func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

mirai.splashPage = function () {

  if (false) {

    if (Cookies.get('smartdoll-splashpage-' + 1244)) {

      $('#splashpage').hide();

    } else {

      $('#featured-slider, #featured-slider-nav').hide();

      $('#splashpage').find('.splashpage-learn-more').click(function (e) {

        e.preventDefault();

        Cookies.set('smartdoll-splashpage-' + 1244, true, {
           expires: 500,
           path: '/',
           domain: window.location.hostname
        });

        window.location.href = $(this).prop('href');

      });

      $('#splashpage').find('.splashpage-close').click(function (e) {

        e.preventDefault();

        Cookies.set('smartdoll-splashpage-' + 1244, true, {
           expires: 500,
           path: '/',
           domain: window.location.hostname
        });

        $('#splashpage').hide();
        $('#featured-slider, #featured-slider-nav').show();

      });

      $('#splashpage').show();

    }

  }

};

mirai.headerCarousel = function () {

  if (true) {

    $('#header-carousel-slider').flexslider({
      animation: "slide",
      pauseOnHover: true,
      directionNav: false,
      smoothHeight: true,
      slideshowSpeed: 6000
    });

  }

};

mirai.mainNavInit = function () {
  $('.nav-bar').stickThis({
    zindex: 7
  }).addClass('is-moved-by-drawer'); // Fixes nav-bar drawer transitions

  var activateSubmenu = function (row) {
    var $row = $(row);
    $row.addClass('menu-aimed-at');
    // $row.find('.site-nav__sub').css({
    //   display: 'block'
    // });
  };

  var deactivateSubmenu = function (row) {
    var $row = $(row);
    $row.removeClass('menu-aimed-at');
    // $row.find('.site-nav__sub').css({
    //   display: 'none'
    // });
  };

  $('.site-nav__main').menuAim({
    submenuDirection: 'below',
    tolerance: 25,
    activate: activateSubmenu,
    deactivate: deactivateSubmenu,
    exitMenu: function () {
      return true;
    }
  });

  var scrolling = true, $window = $(window), $navBar = $('.nav-bar.cloned');

  $window.scroll(function() {
    scrolling = true;
  });

  setInterval( function() {
    scroll();
  }, 250 );

  var scroll = function () {

    if (scrolling) {
      scrolling = false;

      if ($window.scrollTop() > 20) {
        $navBar.addClass('scrolled');
      } else {
        $navBar.removeClass('scrolled');
      }

    }

  }

  scroll();

};

mirai.searchModal = function () {
  $('.open-search').fancybox({
    wrapCSS: 'search__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    beforeShow: function () {
      if (typeof timber !== 'undefined' && typeof timber.RightDrawer !== 'undefined') {
        timber.RightDrawer.close();
      }
    },
    afterShow: function () {
      setTimeout(function() {
        $('#SearchModalContainer').find('input[type=search]').focus();
      }, 500);
    }
  });
};

mirai.languageModal = function () {
  $('.open-language').fancybox({
    wrapCSS: 'localize__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    afterShow: function () {
      $('#LanguageModalContainer').find('a, button').click(function () {
        $.fancybox.close();
      })
    }
  });
};

mirai.apparelHelpModal = function () {
  $('.open-apparel-help-modal').fancybox({
    wrapCSS: 'apparel-help__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    beforeShow: function () {
    },
    afterShow: function () {
      $('#ApparelHelpModalContainer').find('.fancybox-close').click(function () {
        $.fancybox.close();
      })
    }
  });
};

mirai.versionHelpModal = function () {
  $('.open-version-help-modal').fancybox({
    wrapCSS: 'version-help__modal-wrapper',
    fitToView: false,
    autoSize: false,
    autoResize: false,
    autoCenter: false,
    minWidth: '50%',
    maxWidth: 991,
    padding: 0,
    onUpdate: function () {
      //$.fancybox.current.margin = modalMargin();
    },
    helpers: {
      overlay: {
        locked: true
      }
    },
    keys: {
      close: [27] // escape key
    },
    beforeShow: function () {
    },
    afterShow: function () {
      $('#VersionHelpModalContainer').find('.fancybox-close').click(function () {
        $.fancybox.close();
      })
    }
  });
};

mirai.instabewbsModal = function () {
  if (false) {
    $('.open-instabewbs-modal').fancybox({
      wrapCSS: 'instabewbs__modal-wrapper',
      margin: 0,
      padding: 0,
      keys: {
        close: [27] // escape key
      },
      beforeShow: function () {
      },
      afterShow: function () {
        $('#InstabewbsModalContainer').find('a, button').click(function () {
          $.fancybox.close();
        })
      }
    });
  }
};

mirai.checkoutNotesModal = function () {

  var scrollPosition = 0;

  $('.open-checkout-notes-modal').fancybox({
    wrapCSS: 'checkout-notes__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    beforeShow: function () {
      scrollPosition = document.scrollingElement.scrollTop;
      mirai.scrollToTop();
    },
    afterClose: function () {
      mirai.scrollToY(scrollPosition, 1);
    }
  });

};

// Shim for smart doll variant selections
mirai.smartDollSelectors = function (name, options) {
  var changeButton = $('#ChangeVariant');
  var variantSelect = $('.variant-selector');
  var variantBuy = $('.product-single__variant-buy');

  var selectedClass = 'selected';
  var selector = 'input[type=radio][name=' + name + ']';
  var elements = $(selector);

  var product = new Shopify.Product(options.product);

  var onVariantSelected = Shopify.isDefined(options.onVariantSelected) ? options.onVariantSelected : function () {
  };
  var onVariantChange = Shopify.isDefined(options.onVariantChange) ? options.onVariantChange : function () {
  };

  $(document).on('click touchstart', 'label.product-variant__label', function (e) {
    e.preventDefault();

    var selected = $('input#' + $(this).attr('for'));
    selected.prop('checked', true);
    var variant = product.getVariantById(selected.val());

    elements.parent().removeClass(selectedClass);
    selected.parent().addClass(selectedClass);
    onVariantSelected(variant, selected);

    variantSelect.fadeOut(function () {
      variantBuy.fadeIn();
    });
  });

  changeButton.click(function () {
    elements.removeAttr('checked');
    onVariantChange();

    variantBuy.fadeOut(function () {
      variantSelect.fadeIn();
    });
  })
};

mirai.productPage = function (product) {
  product.tag_list = product.tags.join(' ');
  // Coming soon property
  product.coming_soon = product.tag_list.indexOf('coming-soon') > -1;
  // In store only property
  product.in_store_only = product.tag_list.indexOf('in-store-only') > -1;
  // No restock property
  product.no_restock = product.tag_list.indexOf('no-restock') > -1;
  // Back soon property
  product.back_soon = product.tag_list.indexOf('back-soon') > -1;
  // Will restock property
  product.will_restock = product.tag_list.indexOf('will-restock') > -1;
  // Cancelled property
  product.cancelled = product.tag_list.indexOf('cancelled') > -1;
  // Localize options
  product.options = $.map(product.options, function (option) {
    return localize.buildString(option);
  });

  var productSlider = $('#ProductSlider'),
      productThumbs = $('#ProductThumbs'),
      productCarousel = $('#ProductCarousel'),
      productThumbsWrapper = $('.product-single__thumbnails-wrapper');

  var productThumbsViewMore = productThumbs.find('.view-more a').click(function (e) {
    e.preventDefault();
    productThumbsWrapper.addClass('product-single__thumbnails--expanded');
    $(this).hide('fast').parent().remove();
  });

  // Desktop product thumbs
  productThumbs.find('.product-single__thumbnail').fancybox({
    wrapCSS: 'product__image-wrapper',
    padding: 0,
    margin: 120, // Matches margin set in theme style
    nextEffect: 'fade',
    prevEffect: 'fade',
    minWidth: '80%',
    beforeShow: function () {
      var apparelSetImageId = this.element.closest('.product-single__thumbnails-wrapper').data('apparel-image-id');
      if (apparelSetImageId != '' && apparelSetImageId == this.element.parent().data('image-id')) {
        this.inner.append('<span class="product__image-apparel-overlay__plus"></span><span class="product__image-apparel-overlay__image"></span>');
      }
      var alt = this.element.find('img').prop('alt');
      if (alt && alt != product.title) {
        this.title = localize.buildString(alt);
      }
    }
  });

  // Mobile product slider
  // The slider being synced must be initialized first
  productCarousel.flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 100,
    itemMargin: 5,
    asNavFor: '#ProductSlider'
  });

  productSlider.flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: "#ProductCarousel",
    smoothHeight: product.tag_list.indexOf('creator') > -1
  });

  mirai.productEditor(product.id);
  mirai.apparelHelpModal();
  mirai.versionHelpModal();
  mirai.productDescriptionIncludesCollapsible(product.handle);
  mirai.variantGridToggleSoldOut(product.handle);
};

// Product addons UI
// Currenty only works with single variant/no variant products
mirai.productAddon = function (options) {
  var selectedProducts = [];
  var unavailableProducts = [];
  var productLookup = {};
  var collectionLookup = {};

  var $body = $('body');
  var $addon = $('#ProductAddon');
  var $addonTemplate = $("#ProductAddonTemplate");

  var init = function () {
    // Add item from a collection
    $body.on('click', '.product__addon-add a', function (e) {
      e.preventDefault();

      var $link = $(this);
      var collectionHandle = $link.data('collection');
      showModal(collectionHandle);
    });

    // Add selected item
    $body.on('click', '.product__addon-modal a', function (e) {
      e.preventDefault();

      var $gridItem = $(this).parents('.product-grid');
      var productId = $gridItem.data('product');
      var product = productLookup[productId];

      if (product) {
        selectedProducts.push(product);
        refreshData();
      }

      $.fancybox.close();
      refreshList();
    });

    // Remove selected item
    $body.on('click', '.product__addon-remove', function (e) {
      e.preventDefault();

      var $button = $(this);
      var $productAddon = $button.parents('.product__addon');
      var productId = $button.data('product');
      var product = productLookup[productId];
      var index = $.inArray(product, selectedProducts);

      if (index > -1) {
        selectedProducts.splice(index, 1);
        refreshData();
      }

      $productAddon.addClass('is-removed');

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        refreshList();
      }, 600);
    });

    // Init
    $.each(options.collections, function (i, collection) {

      // Localize/parse add from collection label
      collection.description = localize.buildString(collection.description);

      // Add collection to lookup
      collectionLookup[collection.handle] = {};
      collectionLookup[collection.handle].collection = collection;
      // Keep track of number of products in this collection to test if it's going to be shown as empty in the modal
      collectionLookup[collection.handle].unavailableProductsCount = 0;

      $.each(collection.products, function (i, product) {

        // Supplement default product info
        product.variant_id = product.variants[0].id;
        if (product.featured_image) {
          product.thumb_image = product.featured_image.replace(/(\.[^.]*)$/, "_grande_cropped$1");
        } else {
          product.thumb_image = "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_medium_cropped.gif";
        }
        product.price_formatted = Shopify.formatMoney(product.price, options.moneyFormat);

        //product.price_formatted = '¥' + product.price;
        product.collection_handle = collection.handle;

        // Add product to lookup
        productLookup[product.id] = product;

        // Track unavailable products
        if (!product.available) {
          collectionLookup[collection.handle].unavailableProductsCount++;
          unavailableProducts.push(product);
        }

      });

    });

    refreshData();
    refreshList();
  };

  var findProductGridItem = function (product) {
    var $collectionTemplate = $('#collection-' + product.collection_handle);
    return $collectionTemplate.find('.product-grid[data-product=' + product.id + ']');
  };

  var refreshData = function () {
    var counts = {};
    $.each(selectedProducts, function (i, product) {
      counts[product.collection_handle] = (counts[product.collection_handle] || 0) + 1;
    });

    $.each(options.collections, function (i, collection) {
      var count = counts[collection.handle] || 0;
      collection.all_selected = count >= collection.products.length;
      collection.something_selected = count >= 1;
    });
  };

  var refreshList = function () {
    $addon.empty().append(buildList());
  };

  var buildList = function () {
    var source = $addonTemplate.html(),
        template = Handlebars.compile(source);

    var nonEmptyCollections = [];

    $.each(options.collections, function (i, collection) {
      if (collectionLookup[collection.handle].unavailableProductsCount < collectionLookup[collection.handle].collection.products.length) {
        nonEmptyCollections.push(collection);
      }
    });

    var data = {
      selected_products: selectedProducts,
      collections: nonEmptyCollections
    };

    return template(data);
  };

  var buildModal = function (collectionHandle) {
    var $collectionTemplate = $('#collection-' + collectionHandle);
    var $markup = $collectionTemplate.clone();

    // Remove unavailable and selected products
    var removeThese = unavailableProducts.concat(selectedProducts);

    // Remove selected products
    $.each(removeThese, function (i, product) {
      if (product.collection_handle == collectionHandle) {
        $markup.find('.product-grid[data-product=' + product.id + ']').remove();
      }
    });

    // Append select text to each remaing grid item
    var $selectElement = $('<div class="wrapper"><span class="boxed">' + localize.buildString('Select') + '</span></div>');
    $markup.find('.product-grid .grid__image').append($selectElement);

    // Append 'Learn More' text link to each product item
    $.each($('.grid__item', $markup), function(index, el) {

        $('.product__info', el).append('<a href="' + $('a', el).attr('href') + '" target="_blank">(' + localize.buildString("Learn More|詳しく見る") + ')</a>').bind('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            window.open($('a', el).attr('href'));
        });

        if ($('.grid__item', $markup).length < 2) {
          $(el).removeClass('large--one-quarter').addClass('large--one-third');
        }

    });

    // If there are no products left, show message
    if ($markup.find('.product-grid[data-product]').length === 0) {
      $markup.find('.grid-uniform').append('<div class="grid__item large--one-full collection-empty"><h3>' + localize.buildString("(All Sold Out For Now)|(All Sold Out For Now)") + '</h3></div>')
    }

    return $markup;
  };

  var modalMargin = function () {
    return $(window).width() > 991 ? 120 : 0;
  };

  // Show modal
  var showModal = function (collectionHandle) {
    $.fancybox(buildModal(collectionHandle), {
      wrapCSS: 'product__addon-modal',
      fitToView: false,
      autoSize: false,
      autoResize: false,
      autoCenter: false,
      minWidth: '50%',
      maxWidth: 991,
      padding: 0,
      onUpdate: function () {
        //$.fancybox.current.margin = modalMargin();
      },
      helpers: {
        overlay: {
          locked: true
        }
      }
    });
  };

  init();
};

// "Password protect" adding a product to cart
mirai.productLock = function (options) {
  var isLocked = true;
  var lockOpener = 'default';
  var $formContainer = $(options.formSelector);
  var $addToCart = $(options.addToCartSelector);
  var $body;

  var init = function () {
    // General Selectors
    $body = $('body');

    // Override form behavior
    formOverride();

    // I'm special opener
    specialOverride();

    $body.on('submit', '.product__lock-form', function (evt) {
      evt.preventDefault();

      var $lockForm = $(this);
      var userInput = $lockForm.find('input[name=key]').val();
      if (md5(userInput) === options.key) {

        isLocked = false;

        if (lockOpener == 'default') {
        	$formContainer.submit();
        }

        if (lockOpener == 'special') {
            enableAddToCart();
            $('.product-notifications').after('<div class="successes password-success">' + localize.buildString("Go ahead and add to your cart|Go ahead and add to your cart") + '</div>');
        }

      } else {

        if (lockOpener == 'default') {
        	$formContainer.after('<div class="errors qty-error">' + localize.buildString("Invalid password!|パスワード間違っているぞ！") + '</div>');
        }

        if (lockOpener == 'special') {
            $('.product-notifications').after('<div class="errors qty-error">' + localize.buildString("You can't trust the weatherman, not in the summer.") + '</div>');
        }
      }

      $.fancybox.close();
    });
  };

  var enableAddToCart = function () {
    $('#AddToCart').prop('disabled', false).removeClass('disabled').data('unlocked', true);
    $('#AddToCartText').html(localize.buildString("Add to Cart|カートに入れる"));
  }

  var formOverride = function () {
    $formContainer.on('submit', function (evt) {
      // Stop form submit and present unlock screen
      if (isLocked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        lockOpener = 'default';

        showModal();
      }

      // Else allow event to pass through
    });
  };

  var specialOverride = function () {

    var $specialLockOpener = $('.locked-special');

    if ($specialLockOpener.length > 0){

      $specialLockOpener.on('click', function (evt) {

        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (isLocked) {

          // Add class to be styled if desired
          $addToCart.removeClass('is-added').addClass('is-adding');

          // Remove any previous quantity errors
          $('.qty-error').remove();

          lockOpener = 'special';

          showModal();
        }

      });

    }

  };

  var buildModal = function () {
    var build = [];
    build.push('<form class="product__lock-form text-center form-vertical" role="confirm">');

    if (lockOpener == 'default') {
    	build.push('<h3>' + localize.buildString("What&#39;s the password?|パスワードを入力してください") + '</h3>');
    }

    if (lockOpener == 'special') {
    	build.push('<h3>' + localize.buildString("Spy Speak") + '</h3>');
    }

    build.push('<img src="//shop.smartdoll.jp/cdn/shop/t/369/assets/lock.png?v=35823731072835989261744955497" />');

    if (lockOpener == 'default') {
    	build.push('<label for="key">' + localize.buildString("Please enter the password that customer service gave you|顧客サポートに教えてもらったパスワードを入力してください") + '</label>');
        build.push('<input type="password" name="key" placeholder="Password" class="input-full" />');
        build.push('<button type="submit" class="btn btn--full">' + localize.buildString("Add to Cart|カートに入れる") + '</button>');
    }

    if (lockOpener == 'special') {
    	build.push('<label for="key">' + localize.buildString("They said it would rain tomorrow.") + '</label>');
        build.push('<input type="password" name="key" placeholder="Countersign" class="input-full" />');
        build.push('<button type="submit" class="btn btn--full">' + localize.buildString("Submit|Submit") + '</button>');
    }

    build.push('</form>');

    return build.join('');
  };

  var showModal = function () {
    $.fancybox($(buildModal()), {
      wrapCSS: 'product__lock-wrapper',
      margin: 0,
      padding: 0
    });
  };

  init();
};

mirai.collectionPage = function (collection) {
  mirai.collectionToggleSoldOut(collection.handle);
};

mirai.itemEditor = function (itemType, itemId) {
  $(window).load(function () {
    if (window.location.protocol == 'https:') {
      var adminBar = $('#admin_bar_iframe');
      if (adminBar.length >= 1) {
        var editor = $('<a target="_blank" class="btn--secondary btn--small admin__item-editor" href="/admin/' + itemType + 's/' + itemId + '">Edit ' + itemType + '</a>')
        $('body').append(editor);
      }
    }
  });
};

mirai.productEditor = function (productId) {
  mirai.itemEditor('product', productId);
};

mirai.collectionEditor = function (collectionId) {
  mirai.itemEditor('collection', collectionId);
};

mirai.pageEditor = function (pageId) {
  mirai.itemEditor('page', pageId);
};

mirai.promotionReadKey = 'smartdoll-promotion-read-536d5c2caf3d6aa7d96033f6886bd55c';
mirai.promotionReadOnce = false;

mirai.promotion = function () {
  if (mirai.promotionReadOnce) {
    // Check for cookie key
    if (!Cookies.get(mirai.promotionReadKey)) {
      $('#Promotion').show();
      $('#Promotion').removeClass('promo-hidden');
    }

    $('#Promotion').find('a').click(function (e) {
      e.preventDefault();
      Cookies.set(mirai.promotionReadKey, true);
      window.location.href = $(this).prop('href');
    });
  }
};

mirai.injectJapaneseFonts = function () {
  if (!mirai._fontsInjected) {
    var lightFont = new FontFaceObserver('Noto Sans Japanese', {weight: 300});
    var normalFont = new FontFaceObserver('Noto Sans Japanese', {weight: 400});
    var boldFont = new FontFaceObserver('Noto Sans Japanese', {weight: 700});

    Promise.all(
        [
          lightFont.load('日本語', 5000),
          normalFont.load('日本語', 5000),
          boldFont.load('日本語', 5000)
        ]
    ).then(function () {
      $('html').addClass('fonts-loaded');
    }).catch(function (error) { });

    $('<link/>', {
      rel: 'stylesheet',
      type: 'text/css',
      href: '//shop.smartdoll.jp/cdn/shop/t/369/assets/japanese_fonts.scss?v=26558560502115277761744955512'
    }).appendTo('head');

    mirai._fontsInjected = true;
  }
};

mirai.recentlyViewedProducts = (function() {

   var config = {
     howManyToShow: 12,
     howManyToStoreInMemory: 12,
     wrapperId: 'recently-viewed-products',
     templateId: 'recently-viewed-product-template',
     onComplete: null
   };

   var productHandleQueue = [];
   var wrapper = null;
   var template = null;
   var shown = 0;

   var cookie = {
     configuration: {
       expires: 500,
       path: '/',
       domain: window.location.hostname
     },
     name: 'smartdoll-recently-viewed',
     write: function(recentlyViewed) {
       Cookies.set(this.name, recentlyViewed.join(','), this.configuration);
     },
     read: function() {
       var recentlyViewed = [];
       var cookieValue = Cookies.get(this.name);
       if (cookieValue == null) {} else {
         recentlyViewed = cookieValue.split(',');
       }
       return recentlyViewed;
     },
     destroy: function() {
       Cookies.set(this.name, null, this.configuration);
     },
     remove: function(productHandle) {
       var recentlyViewed = this.read();
       var position = jQuery.inArray(productHandle, recentlyViewed);
       if (position !== -1) {
         recentlyViewed.splice(position, 1);
         this.write(recentlyViewed);
       }
     }
   };

   var finalize = function() {
     wrapper.show();
     // If we have a callback.
     if (config.onComplete) {
       try { config.onComplete() } catch (error) { }
     }
   };

   var moveAlong = function() {
     if (productHandleQueue.length && shown < config.howManyToShow && productHandleQueue[0] != 'null') {
       jQuery.ajax({
         dataType: 'json',
         url: '/products/' + productHandleQueue[0] + '.js',
         cache: false,
         success: function(product) {
           wrapper.find('.grid-uniform').append(template(product));
           productHandleQueue.shift();
           shown++;
           moveAlong();
         },
         error: function() {
           //cookie.remove(productHandleQueue[0]);
           productHandleQueue.shift();
           moveAlong();
         }
       });
     }
     else {
       finalize();
     }

   };

   return {

     showRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read();

       wrapper = jQuery('#' + config.wrapperId);

       if (productHandleQueue[0] == 'null') {

         wrapper.hide();

       } else {

         // How many products to show.
         config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

         // If we have any to show.
         if (config.howManyToShow && jQuery('#' + config.templateId).length && wrapper.length) {
           // Getting each product with an Ajax call and rendering it on the page.
           template = Handlebars.compile(jQuery('#' + config.templateId).html());
           moveAlong();
         }

       }

       $('h2 a', wrapper).on('click', function (e) {
         cookie.destroy();
         window.location.reload(false);
       });

     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();
     },

     recordRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read();

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
         var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);
         }

         // Update cookie.
         cookie.write(recentlyViewed);

       }

     }

   };

})();

mirai.relatedProducts = (function () {

  var config = {
    howManyToShow: 12,
    wrapperId: 'related-products',
    templateId: 'related-products-template'
  };

  var products = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var shuffleProducts = function () {
    for (var i = products.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = products[i];
      products[i] = products[j];
      products[j] = temp;
    }
  }

  return {

    showRelatedProducts: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      wrapper = jQuery('#' + config.wrapperId);

      if (wrapper && wrapper.data('related-product-json')) {

        products = wrapper.data('related-product-json');

        if (products.length == 0) {

          wrapper.hide();

        } else {

          shuffleProducts();

          // How many products to show.
          config.howManyToShow = Math.min(products.length, config.howManyToShow);

          // If we have any to show.
          if (config.howManyToShow && jQuery('#' + config.templateId).length && wrapper.length) {

            template = Handlebars.compile(jQuery('#' + config.templateId).html());

            products.forEach(function (product) {

              if (shown < config.howManyToShow) {

                wrapper.find('.grid-uniform').append(template(product));
                shown++;

              }

            });

            wrapper.show();

          }

        }

      }

    },

    getConfig: function () {
      return config;
    },

  };

})();

mirai.instabewbs = function () {
  if (false) {
    var instabewbsCookie = Cookies.get('smartdoll-instabewb-filter');
    var destination = '';

    if (instabewbsCookie == 'enabled') {
      $('body').addClass('instabewbs-enabled');
    } else if (instabewbsCookie == 'disabled') {
      $('body').addClass('instabewbs-disabled');
    } else {
      $('body').addClass('instabewbs-enabled');
    }

    $('body').on('click', '.tag-busts a', function (e) {

      destination = $(e.target).closest('a').attr('href');

      if (instabewbsCookie == 'enabled') {
        // Do nothing
      } else if (instabewbsCookie == 'disabled') {
        // Do nothing
      } else {
        e.preventDefault();
        $('.open-instabewbs-modal').click();
      }

    });

    $('.instabewbs-enable-btn').on('click', function (e) {

      Cookies.set('smartdoll-instabewb-filter', 'enabled', {
         expires: 500,
         path: '/',
         domain: window.location.hostname
      });

      if (destination != '') {
        window.location.href = destination;
      } else {
        window.location.reload(false);
      }

    });

    $('.instabewbs-disable-btn').on('click', function (e) {

      Cookies.set('smartdoll-instabewb-filter', 'disabled', {
         expires: 500,
         path: '/',
         domain: window.location.hostname
      });

      if (destination != '') {
        window.location.href = destination;
      } else {
        window.location.reload(false);
      }

    });
  }
};

mirai.releaseCalendar = function () {
	var segmentString = window.location.pathname.replace(/\/$/, "");
    var segmentArray = segmentString.split( '/' );
    var lastSegment = segmentArray.pop();

    if (lastSegment == 'release-history') {
		$('.release-calendar-header').first().next('.release-calendar-tags').find('li').last().find('a')[0].click();
    } else {
      	$('.release-calendar-header[data-year="'+lastSegment.split('-')[0]+'"]').next('.release-calendar-tags').show();
        $('.release-calendar-header[data-year="'+lastSegment.split('-')[0]+'"]').addClass('open').removeClass('closed');
      	$('.release-calendar-loader').hide();
      	$('.release-calendar-grid').show();
    }

    $('.release-calendar-header').on('click', function (e) {

      $('.release-calendar-header').not(this).next('.release-calendar-tags').slideUp();
      $(this).next('.release-calendar-tags').slideDown();

      $('.release-calendar-header').not(this).addClass('closed').removeClass('open');
      $(this).addClass('open').removeClass('closed');

    });
};

var whistleblowerAlertsTimeout;

mirai.productWhistleblower = function () {

  var $body = $('body');
  var $whistleblowerNotifyBtn = $('.product-whistleblower-input button');
  var $whistleblowerNotifyInput = $('.product-whistleblower-input input');
  var $whistleblowerAlerts = $('.product-whistleblower-alerts');

  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var requiresConfirmation = true;
  var modalFormSelector = '.product-confirmation-modal-form.whistleblower-confirmation';

  var onWhistleblowerNotifyBtnClick = function (event) {

    if ($whistleblowerNotifyInput.val() !== '') {

      if (emailRegex.test($whistleblowerNotifyInput.val())) {

        if (requiresConfirmation) {

          event.preventDefault();
          event.stopImmediatePropagation();

          showAgreementModal();

          $body.on('submit', modalFormSelector, function (evt) {
            evt.preventDefault();

            requiresConfirmation = false;
            postData();
            $.fancybox.close();

          });

        } else {
          postData();
        }

      } else {
        showAlerts([{ class: 'error', message: localize.buildString('Please enter a valid E-Mail|正しいメールを入力せよ') }]);
        return false;
      }

    } else {
      showAlerts([{ class: 'error', message: localize.buildString('Please enter a valid E-Mail|正しいメールを入力せよ') }]);
      return false;
    }

  };

  var postData = function () {

    var payload = {
      email: $whistleblowerNotifyInput.val(),
      product_id: product.id
    };

    $whistleblowerNotifyBtn.prop('disabled', true);

    jQuery.ajax({
      method: 'post',
      url: 'https://pewpew.smartdoll.jp/api/whistleblower',
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      cache: false,
      success: function(response) {
        showAlerts([{ class: 'success', message: localize.buildString('Check your inbox if this is your first time signing up!|メール確認してね！') }]);
        $whistleblowerNotifyInput.val('');
        $whistleblowerNotifyBtn.prop('disabled', false);
      },
      error: function() {
        showAlerts([{ class: 'error', message: localize.buildString('Sorry, something went wrong - please let us know what happened!|あらら、何かエラー発生。ぜひおしらせください。') }]);
        $whistleblowerNotifyInput.val('');
        $whistleblowerNotifyBtn.prop('disabled', false);
      }
    });

  };

  $(document).off('click', '.product-whistleblower-input button');
  $(document).on('click', '.product-whistleblower-input button', onWhistleblowerNotifyBtnClick);

  $whistleblowerNotifyInput.keypress(function(event){

    var keycode = (event.keyCode ? event.keyCode : event.which);

    if (keycode === '13'){
      onWhistleblowerNotifyBtnClick();
    }

  });

  var showAlerts = function (passedAlerts, timeout) {

    timeout = typeof timeout !== 'undefined' ? timeout : 5000;

    clearTimeout(whistleblowerAlertsTimeout);

    if (timeout > 0) {
      whistleblowerAlertsTimeout = setTimeout(function(){ showAlerts([]); }, timeout);
    }

    alerts = passedAlerts;
    renderAlerts();

  };

  var renderAlerts = function () {

    $whistleblowerAlerts.empty();

    $.each(alerts, function (i, alert) {

      $whistleblowerAlerts.append('<div class="product-whistleblower-alert-' + alert.class + '">' + alert.message + '</div>');

    });

  };

  // Agreement Modal

  var checkWhistleblowerAgreementRequirements = function () {

    if (
      whistleblowerAgreementRequirements.checkboxOne === 'yes' &&
      whistleblowerAgreementRequirements.checkboxTwo === 'yes' &&
      whistleblowerAgreementRequirements.checkboxThree === 'yes' &&
      whistleblowerAgreementRequirements.checkboxFour === 'yes' &&
      whistleblowerAgreementRequirements.passphrase.toUpperCase() === 'ready for a roast'.toUpperCase()
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  }

  var whistleblowerAgreementRequirements = {
    checkboxOneValue: null,
    checkboxTwoValue: null,
    checkboxThreeValue: null,
    checkboxFourValue: null,
    passphraseValue: '',
    updated() {
      checkWhistleblowerAgreementRequirements(this.value);
    },
    get checkboxOne() {
      return this.checkboxOneValue;
    },
    get checkboxTwo() {
      return this.checkboxTwoValue;
    },
    get checkboxThree() {
      return this.checkboxThreeValue;
    },
    get checkboxFour() {
      return this.checkboxFourValue;
    },
    get passphrase() {
      return this.passphraseValue;
    },
    set checkboxOne(value) {
      this.checkboxOneValue = value;
      this.updated();
    },
    set checkboxTwo(value) {
      this.checkboxTwoValue = value;
      this.updated();
    },
    set checkboxThree(value) {
      this.checkboxThreeValue = value;
      this.updated();
    },
    set checkboxFour(value) {
      this.checkboxFourValue = value;
      this.updated();
    },
    set passphrase(value) {
      this.passphraseValue = value;
      this.updated();
    }
  }

  var buildAgreementModal = function () {

    var build = [];

    build.push('<form class="product-confirmation-modal-form whistleblower-confirmation text-center form-vertical type-whistleblower" role="confirm">');

    build.push('<h3>' + localize.buildString("WARNING") + '</h3>');

    
    build.push('<img src="//shop.smartdoll.jp/cdn/shop/files/slap.png?v=1591520045" />');
    

    build.push('<p class="text-left">' + localize.buildString("Before you give us your email you need to \u003ca href=\"https:\/\/info.smartdoll.jp\/posts\/available-again\" target=\"_blank\"\u003eread the warnings\u003c\/a\u003e. If all is good then check the box next to all the terms you agree with and type \"ready for a roast\" for the passphrase.") + '</p>');

    build.push('<label class="product-confirmation-modal-checkbox" for="product-whistleblower-agreement-checkbox-one"><div><input id="product-whistleblower-agreement-checkbox-one" type="checkbox" value="yes"></div> <div>' + localize.buildString("I understand that stuff may have sold out by the time I get the email alert.") + '</div></label>');
    build.push('<label class="product-confirmation-modal-checkbox" for="product-whistleblower-agreement-checkbox-two"><div><input id="product-whistleblower-agreement-checkbox-two" type="checkbox" value="yes"></div> <div>' + localize.buildString("I understand that you do not own the Internets and have no control over whether emails get to me or not.") + '</div></label>');
    build.push('<label class="product-confirmation-modal-checkbox" for="product-whistleblower-agreement-checkbox-three"><div><input id="product-whistleblower-agreement-checkbox-three" type="checkbox" value="yes"></div> <div>' + localize.buildString("I understand that I need to signup again if I want goodies that have sold out - but also understand that they may not be restocked.") + '</div></label>');
    build.push('<label class="product-confirmation-modal-checkbox" for="product-whistleblower-agreement-checkbox-four"><div><input id="product-whistleblower-agreement-checkbox-four" type="checkbox" value="yes"></div> <div>' + localize.buildString("I understand that if I try to roast you for what is already stated here then you will roast me back") + '</div></label>');
    build.push('<input id="product-whistleblower-agreement-confirmation-passphrase" type="text" name="product_whistleblower_agreement_confirmation_passphrase" placeholder="Enter Passphrase" class="input-full passphrase"  onpaste="return false;" ondrop="return false;" autocomplete="off" />');
    build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("Proceed|Proceed") + '</button>');
    build.push('<button type="button" class="btn--secondary btn--full cancel">' + localize.buildString("Can't Touch This") + '</button>');

    build.push('</form>');

    return build.join('');

  };

  var showAgreementModal = function () {

    $.fancybox($(buildAgreementModal()), {
      wrapCSS: 'product-confirmation-modal-wrapper',
      margin: 0,
      padding: 0,
      afterShow: function () {

        var $confirmationForm = $(modalFormSelector)

        $confirmationForm.find('button.cancel').click(function (e) {
          e.preventDefault();
          $.fancybox.close();
        });

        $confirmationForm.find('#product-whistleblower-agreement-checkbox-one, #product-whistleblower-agreement-checkbox-two, #product-whistleblower-agreement-checkbox-three, #product-whistleblower-agreement-checkbox-four').change(function (e) {

          var prop;

          switch (this.id) {

            case 'product-whistleblower-agreement-checkbox-one':
              prop = 'checkboxOne';
              break;

            case 'product-whistleblower-agreement-checkbox-two':
              prop = 'checkboxTwo';
              break;

            case 'product-whistleblower-agreement-checkbox-three':
              prop = 'checkboxThree';
              break;

            case 'product-whistleblower-agreement-checkbox-four':
              prop = 'checkboxFour';
              break;

          }

          if (this.checked) {
            whistleblowerAgreementRequirements[prop] = this.value;
          } else {
            whistleblowerAgreementRequirements[prop] = null;
          }

        });

        $confirmationForm.find('#product-whistleblower-agreement-confirmation-passphrase').keyup(function (e) {
          whistleblowerAgreementRequirements.passphrase = this.value;
        });

        checkWhistleblowerAgreementRequirements();

      }
    });

  };

};

mirai.checkoutQuestionnaire = function () {

  var agreed = false;

  var modalFormSelector = '.checkout-questionnaire-modal-form';
  var checkoutQuestionnaireHolidayMode = false;
  var checkoutQuestions = [];
  var checkoutQuestionsText = "1. Choose the statement that best fits your mindset:\n-Just ship it—I’m not too worried about the details.\n-I value the handcrafted nature of Smart Doll, don’t mind waiting up to 15 days, and understand I may need to pay additional duties.\n-Greedo definitely shot first.";

  var interval, current_progress = 0, progress = 0, step = 0.5;

  

  

  var cookieName = 'smartdoll-checkout-questionnaire-agree-' + "7a147684f2f67064d0d4e47f8f6a3749";

  var cookieOptions = {
    expires: 500,
    path: '/',
    domain: window.location.hostname
  };

  var parseCheckoutQuestionsText = function () {

    if (checkoutQuestionsText) {

      var checkoutQuestionParts = checkoutQuestionsText.split(/^(\d*)\. (.*)$/gm);

      checkoutQuestionParts.shift();

      checkoutQuestionParts = checkoutQuestionParts.map(function (p) {
        return p.trim();
      });

      var chunkSize = 3;
      var questionNumber = 1;

      for (var i = 0; i < checkoutQuestionParts.length; i += chunkSize) {

        var chunk = checkoutQuestionParts.slice(i, i + chunkSize);

        checkoutQuestions.push({
          number: questionNumber++,
          question: chunk[1],
          answers: chunk[2].split("\n").map(function (a) {
            return a.replace('-', '').trim();
          })
        })

      }

      if (checkoutQuestions.length === 0 || (checkoutQuestions.length && !checkoutQuestions.every(function (question) {
        return question.answers.length >= 2;
      }))) {
        checkoutQuestions = [];
      }

    }

  }

  var checkCheckoutQuestionnaireRequirements = function () {

    if (
      checkoutQuestionnaireRequirements.questions.length &&
      checkoutQuestionnaireRequirements.questions.every(function (q) {
        return q === 'yes';
      })
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  };

  var resetCheckoutQuestionnaireRequirements = function () {

    checkoutQuestionnaireRequirements.questions = checkoutQuestions.map(function () {
      return null;
    });

    agreed = false;

  }

  var checkCheckoutQuestionnaireCookie = function () {

    if (Cookies.get(cookieName)) {
      agreed = true;
    }

  }

  var setCheckoutQuestionnaireCookie = function () {

    Cookies.set(cookieName, true, cookieOptions);

  }

  var removeCheckoutQuestionnaireCookie = function () {

    Cookies.remove(cookieName, cookieOptions);

  }

  var buildCheckoutQuestionnaireModal = function () {

    var build = [];

    build.push('<form class="checkout-questionnaire-modal-form text-center form-vertical" role="confirm" style="max-width: 850px;">');

    if (!checkoutQuestionnaireHolidayMode) {

      build.push('<h3>' + localize.buildString("You can still back out ;-)") + '</h3>');
      build.push('<div class="intro-text text-left">' + localize.buildString("Before proceeding to payment, we invite you to take a moment to reflect on your decision. We want to ensure your choice is fully informed, made freely, and aligned with your expectations.\u003cbr\u003e\u003cbr\u003e\n\nEach Smart Doll is handcrafted in Japan and features unique traits like asymmetry, air bubbles, birthmarks, stretch marks, and non-uniform body parts—hallmarks of the slush casting process that make each doll one of a kind.\u003cbr\u003e\u003cbr\u003e\n\nWe operate with a strong commitment to employee well-being, which means we don’t chase mass production or constant availability. This may affect how often certain items are in stock.\u003cbr\u003e\u003cbr\u003e\n\nWe encourage you to explore other brands to ensure Smart Doll truly resonates with you before committing.\u003cbr\u003e\u003cbr\u003e\n\nPlease note that customs duties may apply. Refunds are processed based on the exchange rate used by your payment provider, which may result in a slightly lower return amount. Orders may take up to 15 business days to ship.") + '</div>');

      checkoutQuestions.forEach(function (question, questionIndex) {

        build.push('<p class="text-left checkout-questionnaire-question">' + localize.buildString(question.question) + '</p>');

        question.answers.forEach(function (answer, answerIndex) {
          build.push('' +
            '<label class="checkout-questionnaire-modal-radio custom-radio" for="checkout-questionnaire-q' + question.number + 'a' + (answerIndex + 1) + '" onclick="">' +
            '<div class="custom-radio-input">' +
            '<input id="checkout-questionnaire-q' + question.number + 'a' + (answerIndex + 1) + '" name="checkout-questionnaire-q' + question.number + '" type="radio" value="' + (answerIndex === 1 ? 'yes' : 'no') + '" data-question-index="' + questionIndex + '">' +
            '<span class="custom-radio-control"></span>' +
            '</div>' +
            '<div class="custom-radio-label">' + localize.buildString(answer) + '</div>' +
            '</label>' +
            '');
        });

      });

      build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("Lemme through to Smart Doll Land!") + '</button>');

    } else {

      build.push('<h3>' + localize.buildString("Back next year!") + '</h3>');
      build.push('<div class="intro-text">' + localize.buildString("\u003cimg src=\"https:\/\/shop.smartdoll.jp\/cdn\/shop\/files\/774e1f6e-3112-4b31-88b7-c27b72f296da.jpg?v=1734929008\u0026width=2500\"\u003e\nThe team will be enjoying a well-deserved break and will return on the 6th of Jan to process your orders. You will be able to use the checkout after the 4th Jan-ish - In the meantime, \u003ca href=\"https:\/\/shop.smartdoll.jp\/collections\/articles-category-shipping\/products\/holiday-mode\"\u003ehere are a few things to read\u003c\/a\u003e ;-)") + '</div>');

    }

    build.push('</form>');

    return build.join('');

  }

  var showCheckoutQuestionnaireModal = function () {

    $.fancybox($(buildCheckoutQuestionnaireModal()), {
      wrapCSS: 'checkout-questionnaire-modal-wrapper',
      margin: 0,
      padding: 0,
      keys: {
        close: [27] // escape key
      },
      beforeShow: function () {

        stopProgressBar();
        resetProgressBar();
        resetCheckoutQuestionnaireRequirements();
        checkCheckoutQuestionnaireRequirements();

      },
      afterShow: function () {

        var $confirmationForm = $(modalFormSelector)

        $confirmationForm.find('input[name^="checkout-questionnaire-q"]').change(function (e) {

          var value = $confirmationForm[0].elements[this.name].value;

          if (value === 'yes') {
            checkoutQuestionnaireRequirements.questions = {index: $(this).data('question-index'), value: value};
          } else {
            checkoutQuestionnaireRequirements.questions = {index: $(this).data('question-index'), value: null};
          }

        });

        resetCheckoutQuestionnaireRequirements();
        checkCheckoutQuestionnaireRequirements();

        $(".checkout-questionnaire__modal-wrapper").find('.fancybox-close').click(function () {
          $.fancybox.close();
        });

      }
    });

  };

  var buildCheckoutQuestionnaireLoaderModal = function () {

    var build = [];

    build.push('<div class="loader-wrapper"><div class="loader-background"><div class="loader-bar"></div></div></div>');

    return build.join('');

  }

  var showCheckoutQuestionnaireLoaderModal = function () {

    $.fancybox($(buildCheckoutQuestionnaireLoaderModal()), {
      wrapCSS: 'checkout-questionnaire-loader-modal-wrapper',
      margin: 0,
      padding: 0,
      afterShow: function () {

        $(".checkout-questionnaire-loader-modal-wrapper").find('.fancybox-close').hide();

        resetProgressBar();
        startProgressBar();

      },
      afterClose: function () {

        stopProgressBar();
        resetProgressBar();

      }
    });

  };

  var checkoutQuestionnaireRequirements = {
    questionValues: [],
    updated() {
      checkCheckoutQuestionnaireRequirements();
    },
    get questions() {
      return this.questionValues;
    },
    set questions(value) {

      if (Array.isArray(value)) {

        this.questionValues = value;
        this.updated();

      } else if (typeof value === 'object' && typeof value.index !== 'undefined' && typeof value.value !== 'undefined') {

        this.questionValues[value.index] = value.value;
        this.updated();

      }

    }
  }

  var startProgressBar = function () {
    interval = setInterval(function () {
      current_progress += step;
      progress = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000
      $(".checkout-questionnaire-loader-modal-wrapper .loader-bar").css('width', progress + '%');
      if (progress >= 100){
        clearInterval(interval);
      } else if (progress >= 70) {
        step = 0.1
      }
    }, 100);
  };

  var stopProgressBar = function () {
    clearInterval(interval);
  }

  var resetProgressBar = function () {
    current_progress = 0;
    progress = 30;
    step = 0.5;
    $(".checkout-questionnaire-loader-modal-wrapper .loader-bar").css('width', '30%');
    clearInterval(interval);
  }

  var init = function () {

    // General Selectors
    $body = $('body');

    parseCheckoutQuestionsText();

    if (checkoutQuestions.length) {

      $body.on('submit', modalFormSelector, function (evt) {

        agreed = true;

        // Disabled 2024-03-26 by Danny
        // if (checkoutQuestionnaireRequirements.questionThree === 'yes') {
        //   setCheckoutQuestionnaireCookie()
        // } else {
        //   removeCheckoutQuestionnaireCookie()
        // }

        $.fancybox.close();

        mirai.scrollToTop();

        showCheckoutQuestionnaireLoaderModal();

        $("button[name=checkout]").click();

      });

      $("button[name=update]").on('click', function (e) {
        $("#cart_form").data('button-trigger', 'update');
      });

      $("button[name=checkout]").on('click', function (e) {
        $("#cart_form").data('button-trigger', 'checkout');
      });

      $("#cart_form").on('submit', function (e) {

        // Disabled 2024-03-26 by Danny
        // checkCheckoutQuestionnaireCookie()

        if (!agreed) {

          if ($(this).data('button-trigger') === 'checkout') {

            e.preventDefault();

            mirai.scrollToTop();

            showCheckoutQuestionnaireModal();

          }

        }

      });

    }

  }

  init();

};

mirai.footerSplashImage = function () {

  var $footerSplashImage = $('#footer-splash-image');

  $footerSplashImage.lazy({

    footerSplashLoader: function (element) {

      jQuery.ajax({
        method: 'get',
        dataType: 'html',
        url: 'https://shop.smartdoll.jp/products/footer-splash-image-pool?view=image-pool-json',
        cache: false,
        success: function(response) {

          var data = $.parseJSON(response);

          if (data.texts !== null && data.texts.length > 0) {

            var randomIndex = Math.floor(Math.random() * data.texts.length);

            element.empty();

            element.html('<img src="' + data.urls[randomIndex] + '"><div>' + data.texts[randomIndex] + '</div>').load();

          }

        },
        error: function() {
	        element.error();
        }
      });

    }

  });

}

mirai.garageIntroTruncate = function () {

  if (true) {

    $('#prototype-sales-garage').find('.garage-intro-truncate-show').click(function (e) {

      e.preventDefault();

      Cookies.remove('smartdoll-garageintrotruncate', {
        expires: 500,
        path: '/',
        domain: window.location.hostname
      });

      $('#prototype-sales-garage .collection-description').removeClass('truncated');
      $('#prototype-sales-garage .garage-intro-truncate-show').hide();
      $('#prototype-sales-garage .garage-intro-truncate-hide').show();

    });

    $('#prototype-sales-garage').find('.garage-intro-truncate-hide').click(function (e) {

      e.preventDefault();

      Cookies.set('smartdoll-garageintrotruncate', true, {
        expires: 500,
        path: '/',
        domain: window.location.hostname
      });

      $('#prototype-sales-garage .collection-description').addClass('truncated');
      $('#prototype-sales-garage .garage-intro-truncate-show').show();
      $('#prototype-sales-garage .garage-intro-truncate-hide').hide();
      window.scrollTo(0, 0);

    });

    if (Cookies.get('smartdoll-garageintrotruncate')) {

      $('#prototype-sales-garage .collection-description').addClass('truncated');

      $('#prototype-sales-garage .garage-intro-truncate-show').show();

    } else {

      $('#prototype-sales-garage .collection-description').removeClass('truncated');

      $('#prototype-sales-garage .garage-intro-truncate-hide').show();

    }

  }

}

mirai.productDescriptionIncludesCollapsible = function (productHandle) {

  if (true && productHandle) {

    var cookieName = 'smartdoll-' + productHandle + '-description-includes-collapse';

    var cookieOptions = {
      expires: 500,
      path: '/',
      domain: window.location.hostname
    };

    var collapsedClass = 'collapsed';

    var $container = $('.product-description-includes-container');
    var $showBtn = $('.product-description-includes-collapsible-show');
    var $hideBtn = $('.product-description-includes-collapsible-hide');

    function collapse() {

      $container.addClass(collapsedClass);
      $showBtn.show();
      $hideBtn.hide();

      window.scrollTo(0, 0);

    }

    function expand() {

      $container.removeClass(collapsedClass);
      $showBtn.hide();
      $hideBtn.show();

    }

    $showBtn.click(function (e) {

      e.preventDefault();

      Cookies.remove(cookieName, cookieOptions);

      expand();

    });

    $hideBtn.click(function (e) {

      e.preventDefault();

      Cookies.set(cookieName, true, cookieOptions);

      collapse();

    });

    Cookies.get(cookieName) ? collapse() : expand();

  }

}

// Show confirmation modal before allowing add-to-cart
mirai.productAddToCartConfirmation = function (options) {

  var requiresConfirmation = true;
  var type = options.type || 'existing-customer';
  var confirmationHeading = options.confirmationHeading || "Confirmation|Confirmation";
  var confirmationText = options.confirmationText || "By Adding to Cart you are confirming to have read the product page|By Adding to Cart you are confirming to have read the product page";
  var confirmationQuestionsText = options.confirmationQuestionsText || null;
  var confirmationQuestions = [];
  var modalFormSelector = '.product-confirmation-modal-form.add-to-cart-confirmation';

  var $formContainer = $(options.formSelector);
  var $addToCart = $(options.addToCartSelector);
  var $body;

  var cookieName = 'smartdoll-add-to-cart-questionnaire-agree-' + type;

  var cookieOptions = {
    expires: 500,
    path: '/',
    domain: window.location.hostname
  };

  var parseConfirmationQuestionsText = function () {

    if (confirmationQuestionsText) {

      var confirmationQuestionParts = confirmationQuestionsText.split(/^(\d*)\. (.*)$/gm);

      confirmationQuestionParts.shift();

      confirmationQuestionParts = confirmationQuestionParts.map(function (p) {
        return p.trim();
      });

      var chunkSize = 3;
      var questionNumber = 1;

      for (var i = 0; i < confirmationQuestionParts.length; i += chunkSize) {

        var chunk = confirmationQuestionParts.slice(i, i + chunkSize);

        confirmationQuestions.push({
          number: questionNumber++,
          question: chunk[1],
          answers: chunk[2].split("\n").map(function (a) {
            return a.trim().replace('-', '');
          })
        })

      }

      if (confirmationQuestions.length === 0 || (confirmationQuestions.length && !confirmationQuestions.every(function (question) {
        return question.answers.length >= 2;
      }))) {
        requiresConfirmation = false;
      }

    }

  }

  var checkDollConfirmationQuestionnaireRequirements = function () {

    if (
      dollConfirmationQuestionnaireRequirements.questions.length &&
      dollConfirmationQuestionnaireRequirements.questions.every(function (q) {
        return q === 'yes';
      })
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  };

  var resetDollConfirmationQuestionnaireRequirements = function () {

    dollConfirmationQuestionnaireRequirements.questions = confirmationQuestions.map(function () {
      return null;
    });

  };

  var checkLicensedDollAgreementRequirements = function () {

    if (
      licensedDollAgreementRequirements.checkboxOne === 'yes' &&
      licensedDollAgreementRequirements.checkboxTwo === 'yes' &&
      licensedDollAgreementRequirements.checkboxThree === 'yes' &&
      licensedDollAgreementRequirements.checkboxFour === null &&
      licensedDollAgreementRequirements.checkboxFive === 'yes' &&
      licensedDollAgreementRequirements.passphrase.toUpperCase() === 'agree'.toUpperCase()
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  };

  var checkConfirmationQuestionnaireRequirements = function () {

    if (
      confirmationQuestionnaireRequirements.questionOne === 'yes' &&
      confirmationQuestionnaireRequirements.questionTwo === 'yes' &&
      confirmationQuestionnaireRequirements.questionThree === 'yes' &&
      confirmationQuestionnaireRequirements.questionFour === 'yes'
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  };

  var resetConfirmationQuestionnaireRequirements = function () {

    confirmationQuestionnaireRequirements.questionOne = null;
    confirmationQuestionnaireRequirements.questionTwo = null;
    confirmationQuestionnaireRequirements.questionThree = null;
    confirmationQuestionnaireRequirements.questionFour = null;

  };

  var checkChaosConfirmationQuestionnaireRequirements = function () {

    if (
      chaosConfirmationQuestionnaireRequirements.questions.length &&
      chaosConfirmationQuestionnaireRequirements.questions.every(function (q) {
        return q === 'yes';
      })
    ) {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', false).removeClass('disabled');
    } else {
      $(modalFormSelector).find('button[type=submit]').prop('disabled', true).addClass('disabled');
    }

  };

  var resetChaosConfirmationQuestionnaireRequirements = function () {

    chaosConfirmationQuestionnaireRequirements.questions = confirmationQuestions.map(function () {
      return null;
    });

  };

  var dollConfirmationQuestionnaireRequirements = {
    questionValues: [],
    updated() {
      checkDollConfirmationQuestionnaireRequirements();
    },
    get questions() {
      return this.questionValues;
    },
    set questions(value) {

      if (Array.isArray(value)) {

        this.questionValues = value;
        this.updated();

      } else if (typeof value === 'object' && typeof value.index !== 'undefined' && typeof value.value !== 'undefined') {

        this.questionValues[value.index] = value.value;
        this.updated();

      }

    }
  }

  var licensedDollAgreementRequirements = {
    checkboxOneValue: null,
    checkboxTwoValue: null,
    checkboxThreeValue: null,
    checkboxFourValue: null,
    checkboxFiveValue: null,
    passphraseValue: '',
    updated() {
      checkLicensedDollAgreementRequirements();
    },
    get checkboxOne() {
      return this.checkboxOneValue;
    },
    get checkboxTwo() {
      return this.checkboxTwoValue;
    },
    get checkboxThree() {
      return this.checkboxThreeValue;
    },
    get checkboxFour() {
      return this.checkboxFourValue;
    },
    get checkboxFive() {
      return this.checkboxFiveValue;
    },
    get passphrase() {
      return this.passphraseValue;
    },
    set checkboxOne(value) {
      this.checkboxOneValue = value;
      this.updated();
    },
    set checkboxTwo(value) {
      this.checkboxTwoValue = value;
      this.updated();
    },
    set checkboxThree(value) {
      this.checkboxThreeValue = value;
      this.updated();
    },
    set checkboxFour(value) {
      this.checkboxFourValue = value;
      this.updated();
    },
    set checkboxFive(value) {
      this.checkboxFiveValue = value;
      this.updated();
    },
    set passphrase(value) {
      this.passphraseValue = value;
      this.updated();
    }
  }

  var confirmationQuestionnaireRequirements = {
    questionOneValue: null,
    questionTwoValue: null,
    questionThreeValue: null,
    questionFourValue: null,
    updated() {
      checkConfirmationQuestionnaireRequirements();
    },
    get questionOne() {
      return this.questionOneValue;
    },
    get questionTwo() {
      return this.questionTwoValue;
    },
    get questionThree() {
      return this.questionThreeValue;
    },
    get questionFour() {
      return this.questionFourValue;
    },
    set questionOne(value) {
      this.questionOneValue = value;
      this.updated();
    },
    set questionTwo(value) {
      this.questionTwoValue = value;
      this.updated();
    },
    set questionThree(value) {
      this.questionThreeValue = value;
      this.updated();
    },
    set questionFour(value) {
      this.questionFourValue = value;
      this.updated();
    }
  }

  var chaosConfirmationQuestionnaireRequirements = {
    questionValues: [],
    updated() {
      checkChaosConfirmationQuestionnaireRequirements();
    },
    get questions() {
      return this.questionValues;
    },
    set questions(value) {

      if (Array.isArray(value)) {

        this.questionValues = value;
        this.updated();

      } else if (typeof value === 'object' && typeof value.index !== 'undefined' && typeof value.value !== 'undefined') {

        this.questionValues[value.index] = value.value;
        this.updated();

      }

    }
  }

  var init = function () {

    // General Selectors
    $body = $('body');

    parseConfirmationQuestionsText();
    setAddToCartQuestionnaireCookieName();

    // Override form behavior
    formOverride();

    $body.on('submit', modalFormSelector, function (evt) {
      evt.preventDefault();

      var $confirmationForm = $(this);

      // Disabled 2024-06-11 by Danny (Chaos Questionnaire converted to text-based, don't know which question is cookie-prompt)
      // if (type === 'chaos-confirmation-questionnaire') {
      //
      //   if (chaosConfirmationQuestionnaireRequirements.questionThree === 'yes') {
      //     setAddToCartQuestionnaireCookie()
      //   } else {
      //     removeAddToCartQuestionnaireCookie()
      //   }
      //
      // }

      // Disabled 2024-03-26 by Danny
      // if (type === 'doll-confirmation-questionnaire') {
      //   setAddToCartQuestionnaireCookie()
      // }

      if (type === 'existing-customer') {

        var userInput = $confirmationForm.find('input[name=order_number]').val();

        if (userInput !== '') {

          requiresConfirmation = false;
          $formContainer.submit();

        } else {
          $formContainer.after('<div class="errors qty-error">' + localize.buildString("Invalid Order Number|Invalid Order Number") + '</div>');
        }

      } else {

        requiresConfirmation = false;
        $formContainer.submit();

      }

      $.fancybox.close();
    });

  };

  var formOverride = function () {

    $formContainer.on('submit', function (evt) {
      // Stop form submit and present unlock screen
      if (requiresConfirmation && !Cookies.get(cookieName)) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        showAddToCartQuestionnaireModal();
      }

      // Else allow event to pass through
    });

  };

  var setAddToCartQuestionnaireCookieName = function () {

    if (type === 'chaos-confirmation-questionnaire') {

      

      

      // Disabled 2024-06-11 by Danny
      // cookieName = cookieName + '-' + "ad544fe449511722ceceec4dfac4bfcf"
      cookieName = cookieName + '-DISABLED'

    } else if (type === 'doll-confirmation-questionnaire') {

      

      

      // Disabled 2024-03-26 by Danny
      // cookieName = cookieName + '-' + "443010f1f5996aec011875bf1eec68e4"
      cookieName = cookieName + '-DISABLED'

    }

  }

  var setAddToCartQuestionnaireCookie = function () {

    Cookies.set(cookieName, true, cookieOptions);

  }

  var removeAddToCartQuestionnaireCookie = function () {

    Cookies.remove(cookieName, cookieOptions);

  }

  var buildAddToCartQuestionnaireModal = function () {

    var build = [];

    

    

    build.push('<form class="product-confirmation-modal-form add-to-cart-confirmation text-center form-vertical type-' + (type || 'default') + '" role="confirm" style="max-width: 650px;">');

    build.push('<h3>' + localize.buildString(confirmationHeading) + '</h3>');

    if (type === 'existing-customer') {

      build.push('<label for="key">' + localize.buildString(confirmationText) + '</label>');
      build.push('<input type="text" name="order_number" placeholder="Order Number" class="input-full" />');
      build.push('<button type="submit" class="btn btn--full">' + localize.buildString("Add to Cart|カートに入れる") + '</button>');

    } else if (type === 'doll-confirmation-questionnaire' || type === 'chaos-confirmation-questionnaire') {

      // Builds radio groups of questions and answers from text split by regex previously

      if (type === 'chaos-confirmation-questionnaire') {
        
          build.push('<img src="//shop.smartdoll.jp/cdn/shop/files/slap.png?v=1591520045" />');
        
      }

      build.push('<p class="text-left">' + localize.buildString(confirmationText) + '</p>');

      confirmationQuestions.forEach(function (question, questionIndex) {

        build.push('<p class="text-left product-confirmation-question">' + localize.buildString(question.question) + '</p>');

        question.answers.forEach(function (answer, answerIndex) {
          build.push('' +
            '<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q' + question.number + 'a' + (answerIndex + 1) + '" onclick="">' +
              '<div class="custom-radio-input">' +
                '<input id="confirmation-questionnaire-q' + question.number + 'a' + (answerIndex + 1) + '" name="confirmation-questionnaire-q' + question.number + '" type="radio" value="' + (answerIndex === 1 ? 'yes': 'no') +'" data-question-index="' + questionIndex + '">' +
                '<span class="custom-radio-control"></span>' +
              '</div>' +
              '<div class="custom-radio-label">' + localize.buildString(answer) + '</div>' +
            '</label>' +
          '');
        });

      });

      if (type === 'doll-confirmation-questionnaire') {
        build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("Proceed") + '</button>');
      }

      if (type === 'chaos-confirmation-questionnaire') {
        build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("Proceed|進行する") + '</button>');
      }

    } else if (type === 'licensed-doll') {

      
        build.push('<img src="//shop.smartdoll.jp/cdn/shop/files/chitose-doll.jpg?v=1619049545" />');
      

      build.push('<p class="text-left">' + localize.buildString(confirmationText) + '</p>');

      build.push('<label class="product-confirmation-modal-checkbox" for="licensed-doll-product-agreement-checkbox-one"><div><input id="licensed-doll-product-agreement-checkbox-one" type="checkbox" value="yes"></div> <div>' + localize.buildString("Checkbox One|Checkbox One") + '</div></label>');
      build.push('<label class="product-confirmation-modal-checkbox" for="licensed-doll-product-agreement-checkbox-two"><div><input id="licensed-doll-product-agreement-checkbox-two" type="checkbox" value="yes"></div> <div>' + localize.buildString("Checkbox Two|Checkbox Two") + '</div></label>');
      build.push('<label class="product-confirmation-modal-checkbox" for="licensed-doll-product-agreement-checkbox-three"><div><input id="licensed-doll-product-agreement-checkbox-three" type="checkbox" value="yes"></div> <div>' + localize.buildString("Checkbox Three|Checkbox Three") + '</div></label>');
      build.push('<label class="product-confirmation-modal-checkbox" for="licensed-doll-product-agreement-checkbox-four"><div><input id="licensed-doll-product-agreement-checkbox-four" type="checkbox" value="yes"></div> <div>' + localize.buildString("Honeypot Checkbox Four|Honeypot Checkbox Four") + '</div></label>');
      build.push('<label class="product-confirmation-modal-checkbox" for="licensed-doll-product-agreement-checkbox-five"><div><input id="licensed-doll-product-agreement-checkbox-five" type="checkbox" value="yes"></div> <div>' + localize.buildString("Checkbox Five|Checkbox Five") + '</div></label>');
      build.push('<input id="licensed-doll-product-agreement-confirmation-passphrase" type="text" name="licensed_doll_product_agreement_confirmation_passphrase" placeholder="Enter Passphrase" class="input-full passphrase"  onpaste="return false;" ondrop="return false;" autocomplete="off" />');
      build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("Proceed|Proceed") + '</button>');
      build.push('<button type="button" class="btn--secondary btn--full cancel">' + localize.buildString("Cancel|Cancel") + '</button>');

    } else if (type === 'confirmation-questionnaire') {

      

      build.push('<p class="text-left">' + localize.buildString(confirmationText) + '</p>');

      build.push('<p class="text-left product-confirmation-question">' + localize.buildString("1. Does this product include a body?") + '</p>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q1a1" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q1a1" name="confirmation-questionnaire-q1" type="radio" value="no"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Of course") + '</div></label>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q1a2" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q1a2" name="confirmation-questionnaire-q1" type="radio" value="yes"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Nope") + '</div></label>');
      build.push('<p class="text-left product-confirmation-question">' + localize.buildString("2. Do you have a body for this Option Head?") + '</p>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q2a1" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q2a1" name="confirmation-questionnaire-q2" type="radio" value="no"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Nope") + '</div></label>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q2a2" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q2a2" name="confirmation-questionnaire-q2" type="radio" value="yes"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Yes") + '</div></label>');
      build.push('<p class="text-left product-confirmation-question">' + localize.buildString("3. Are you expecting to be sold a body later - and\/or for the price difference of a Smart Doll?") + '</p>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q3a1" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q3a1" name="confirmation-questionnaire-q3" type="radio" value="no"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Yes") + '</div></label>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q3a2" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q3a2" name="confirmation-questionnaire-q3" type="radio" value="yes"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("No") + '</div></label>');
      build.push('<p class="text-left product-confirmation-question">' + localize.buildString("4. You are a Smart Doll owner that has previously ordered from this site or are buying a Smart Doll at the same time?") + '</p>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q4a1" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q4a1" name="confirmation-questionnaire-q4" type="radio" value="no"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Nope") + '</div></label>');
      build.push('<label class="product-confirmation-modal-radio custom-radio" for="confirmation-questionnaire-q4a2" onclick=""><div class="custom-radio-input"><input id="confirmation-questionnaire-q4a2" name="confirmation-questionnaire-q4" type="radio" value="yes"><span class="custom-radio-control"></span></div> <div class="custom-radio-label">' + localize.buildString("Yep") + '</div></label>');
      build.push('<button type="submit" class="btn btn--full disabled" disabled>' + localize.buildString("By the power of Grayskull") + '</button>');

    } else {

      build.push('<label for="key" style="margin-bottom:10px;">' + localize.buildString(confirmationText) + '</label>');
      build.push('<button type="submit" class="btn btn--full">' + localize.buildString("Add to Cart|カートに入れる") + '</button>');
      build.push('<button type="button" class="btn--secondary btn--full cancel">' + localize.buildString("Cancel|Cancel") + '</button>');

    }

    build.push('</form>');

    return build.join('');

  };

  var showAddToCartQuestionnaireModal = function () {

    $.fancybox($(buildAddToCartQuestionnaireModal()), {
      wrapCSS: 'product-confirmation-modal-wrapper',
      margin: 0,
      padding: 0,
      afterShow: function () {

        $confirmationForm = $(modalFormSelector)

        if (type !== 'existing-customer') {

          $confirmationForm.find('button.cancel').click(function (e) {
            e.preventDefault();
            $.fancybox.close();
          });

        }

        if (type === 'doll-confirmation-questionnaire') {

          $confirmationForm.find('input[name^="confirmation-questionnaire-q"]').change(function (e) {

            var value = $confirmationForm[0].elements[this.name].value;

            if (value === 'yes') {
              dollConfirmationQuestionnaireRequirements.questions = { index: $(this).data('question-index'), value: value };
            } else {
              dollConfirmationQuestionnaireRequirements.questions = { index: $(this).data('question-index'), value: null };
            }

          });

          resetDollConfirmationQuestionnaireRequirements();
          checkDollConfirmationQuestionnaireRequirements();

        }

        if (type === 'licensed-doll') {

          $confirmationForm.find('#licensed-doll-product-agreement-checkbox-one, #licensed-doll-product-agreement-checkbox-two, #licensed-doll-product-agreement-checkbox-three, #licensed-doll-product-agreement-checkbox-four, #licensed-doll-product-agreement-checkbox-five').change(function (e) {

            var prop;

            switch (this.id) {

              case 'licensed-doll-product-agreement-checkbox-one':
                prop = 'checkboxOne';
                break;

              case 'licensed-doll-product-agreement-checkbox-two':
                prop = 'checkboxTwo';
                break;

              case 'licensed-doll-product-agreement-checkbox-three':
                prop = 'checkboxThree';
                break;

              case 'licensed-doll-product-agreement-checkbox-four':
                prop = 'checkboxFour';
                break;

              case 'licensed-doll-product-agreement-checkbox-five':
                prop = 'checkboxFive';
                break;

            }

            if (this.checked) {
              licensedDollAgreementRequirements[prop] = this.value;
            } else {
              licensedDollAgreementRequirements[prop] = null;
            }

          });

          $confirmationForm.find('#licensed-doll-product-agreement-confirmation-passphrase').keyup(function (e) {
            licensedDollAgreementRequirements.passphrase = this.value;
          });

          checkLicensedDollAgreementRequirements();

        }

        if (type === 'confirmation-questionnaire') {

          $confirmationForm.find('input[name=confirmation-questionnaire-q1], input[name=confirmation-questionnaire-q2], input[name=confirmation-questionnaire-q3], input[name=confirmation-questionnaire-q4]').change(function (e) {

            var prop;
            var value = $confirmationForm[0].elements[this.name].value;

            switch (this.name) {

              case 'confirmation-questionnaire-q1':
                prop = 'questionOne';
                break;

              case 'confirmation-questionnaire-q2':
                prop = 'questionTwo';
                break;

              case 'confirmation-questionnaire-q3':
                prop = 'questionThree';
                break;

              case 'confirmation-questionnaire-q4':
                prop = 'questionFour';
                break;

            }

            if (value === 'yes') {
              confirmationQuestionnaireRequirements[prop] = value;
            } else {
              confirmationQuestionnaireRequirements[prop] = null;
            }

          });

          resetConfirmationQuestionnaireRequirements();
          checkConfirmationQuestionnaireRequirements();

        }

        if (type === 'chaos-confirmation-questionnaire') {

          $confirmationForm.find('input[name^="confirmation-questionnaire-q"]').change(function (e) {

            var value = $confirmationForm[0].elements[this.name].value;

            if (value === 'yes') {
              chaosConfirmationQuestionnaireRequirements.questions = {index: $(this).data('question-index'), value: value};
            } else {
              chaosConfirmationQuestionnaireRequirements.questions = {index: $(this).data('question-index'), value: null};
            }

          });

          resetChaosConfirmationQuestionnaireRequirements();
          checkChaosConfirmationQuestionnaireRequirements();

        }

      }
    });

  };

  init();

};

mirai.collapsibleStickySidebarInit = function () {

  var topOfFilter, scrolling = true, $window = $(window), $collapsibleStickySidebar = $('#collapsible-sticky-sidebar'), $grid = $('#collapsible-sticky-sidebar').parentsUntil('.grid, .grid-flexbox').parent(), menuOpen = false, isStuck = false, isMobile = window.innerWidth <= 480;
  var gutter = 30;

  if ($collapsibleStickySidebar.length > 0) {

    $collapsibleStickySidebar.on('recalculate', function (e) {

      setCloneCss();

    });

    var $collapsibleStickySidebarClone = $collapsibleStickySidebar.clone()

    $collapsibleStickySidebarClone.attr('id', 'collapsible-sticky-sidebar-cloned');
    $collapsibleStickySidebarClone.addClass('collapsible-sticky-sidebar-cloned').appendTo('body').hide();

    var onFilterHeaderClick = function (e) {

      if (!menuOpen) {

        menuOpen = true;
        $collapsibleStickySidebar.removeClass('collapse');
        $collapsibleStickySidebarClone.removeClass('collapse');
        setCloneCss();

        if (isStuck) {
          $('html, body').css({ overflow: 'hidden' });
        }

      } else {

        menuOpen = false;
        $collapsibleStickySidebar.addClass('collapse');
        $collapsibleStickySidebarClone.addClass('collapse');
        $('html, body').css({ overflow: 'auto' });

      }

    }

    $collapsibleStickySidebar.find('h5').off('click');
    $collapsibleStickySidebarClone.find('h5').off('click');

    $collapsibleStickySidebar.find('h5').click(onFilterHeaderClick);
    $collapsibleStickySidebarClone.find('h5').click(onFilterHeaderClick);

    $window.scroll(function() {
      scroll();
    });

    var setIsMobile = function () {
      isMobile = window.innerWidth <= 480;
    }

    var setCloneCss = function () {

      var windowHeight = window.innerHeight;
      var scrollTop = $(window).scrollTop();
      var collapsibleStickySidebarHeight = $collapsibleStickySidebar.outerHeight();
      var gridTop = $grid.offset().top;
      var gridHeight = $grid.outerHeight();
      var gridBottom = gridTop + gridHeight;
      var collapsibleStickySidebarDistanceFromTop = $('.nav-bar').height() + (isMobile ? 0 : gutter);
      var collapsibleStickySidebarBottom = scrollTop + collapsibleStickySidebarDistanceFromTop + collapsibleStickySidebarHeight;

      if (isMobile) {

        $collapsibleStickySidebarClone.css({
          left: '',
          top: '',
          height: windowHeight - $('.nav-bar').height(),
          width: '100%'
        });

      } else {

        var visibleViewport = windowHeight - ($('.nav-bar').height() + gutter) - $('.static-footer-nav-bar').height();

        if (collapsibleStickySidebarBottom >= gridBottom) {

          $collapsibleStickySidebarClone.css({
            left: $collapsibleStickySidebar.offset().left,
            top: gridBottom - (scrollTop + collapsibleStickySidebarHeight),
            width: $collapsibleStickySidebar.width() - 1,
            height: 'auto'
          });

        } else {

          $collapsibleStickySidebarClone.css({
            left: $collapsibleStickySidebar.offset().left,
            top: collapsibleStickySidebarDistanceFromTop,
            width: $collapsibleStickySidebar.width() - 1,
            height: collapsibleStickySidebarHeight > visibleViewport ? (visibleViewport - gutter) : 'auto'
          });

        }

      }

    }

    var stick = function () {

      $collapsibleStickySidebarClone.show();
      setCloneCss();
      $collapsibleStickySidebar.css({ visibility: 'hidden' });
      isStuck = true;

    }

    var unStick = function () {

      $collapsibleStickySidebarClone.hide();
      $collapsibleStickySidebar.css({ visibility: 'visible' });
      $('html, body').css({ overflow: 'auto' });
      isStuck = false;

    }

    var scroll = function () {

      topOfFilter = $collapsibleStickySidebar.offset().top;

      if (($window.scrollTop() + $('.nav-bar').height() + (isMobile ? 0 : gutter)) > topOfFilter) {
        stick();
      } else {
        unStick();
      }

      if (isMobile && menuOpen && isStuck) {
        $('html, body').css({overflow: 'hidden'});
      }

    }

    scroll();

    $window.resize(function() {
      resize();
    });

    var resize = function () {

      setIsMobile();
      setCloneCss();

    }

    resize();

  }

};

mirai.variantGridDrawers = function () {

  var $window = $(window), $variantGrids = $('.grid-flexbox.variant-grid'), gridSize = 0;

  function getGridSize() {
    if ((window.innerWidth || document.documentElement.clientWidth) < 481) {
      return 1;
    }
    if ((window.innerWidth || document.documentElement.clientWidth) < 992) {
      return 2;
    }
    if ((window.innerWidth || document.documentElement.clientWidth) > 991) {
      return 4;
    }
  }

  function closeOpenDrawers(callback) {

    var $openDrawers = $('.variant-grid-drawer.open');
    var openDrawersTotal = $openDrawers.length;

    $('.variant-grid-drawer-open-btn').removeClass('open');

    if (openDrawersTotal === 0) {
      if (typeof callback === 'function') callback();
    } else {

      $openDrawers.each(function (index, el) {

        $(el).animate({
          opacity: 'hide',
          height: 'hide',
          paddingTop: 'hide',
          paddingBottom: 'hide'
        }, 250, 'swing', function () {

          $(el).removeClass('open');

          if (index === openDrawersTotal - 1) {

            var $gridItems = $(el).siblings('.grid-flexbox__item');
            var $drawers = $(el).siblings('.grid-flexbox__item');

            $gridItems.css({
              'order': 0
            });

            $drawers.css({
              'order': 0
            });

            if (typeof callback === 'function') callback();

          }

        });

      });

    }

  }

  function openVariantGridItemDrawer(variantId) {

    var $drawer = $('#variant-grid-drawer-' + variantId);
    var $gridItem = $('#variant-grid-item-' + variantId);
    var $previousGridItems = $gridItem.prevAll('.grid-flexbox__item');
    var $nextGridItems = $gridItem.nextAll('.grid-flexbox__item');
    var gridItemIndex = $gridItem.data('index');
    var rowIndex = Math.ceil(gridItemIndex / gridSize);

    $previousGridItems.css({
      'order': rowIndex - 1
    });

    $gridItem.css({
      'order': rowIndex
    });

    $nextGridItems.css({
      'order': rowIndex + 2
    });

    for (var p = ((rowIndex - 1) * gridSize) + 1; p < gridItemIndex; p++) {
      $gridItem.prevAll('div[data-index=' + p + ']').css({
        'order': rowIndex
      });
    }

    for (var n = gridItemIndex + 1; n <= rowIndex * gridSize; n++) {
      $gridItem.nextAll('.grid-flexbox__item[data-index=' + n + ']').css({
        'order': rowIndex
      });
    }

    $drawer.css({
      'order': rowIndex + 1
    });

    $drawer.animate({
      opacity: 'show',
      height: 'show',
      paddingTop: 'show',
      paddingBottom: 'show'
    }, 250, 'swing', function () {

      mirai.scrollToElement($drawer[0], 250, -125);
      $drawer.addClass('open');

    });

  }

  $variantGrids.each(function (variantGridIndex, variantGridEl) {

    $('.variant-grid-drawer-open-btn', variantGridEl).each(function (btnIndex, btnEl) {

      $(btnEl).click(function (e) {

        if ($(btnEl).hasClass('open')) {

          $(btnEl).removeClass('open');
          closeOpenDrawers();

        } else {

          closeOpenDrawers(function () {

            $(btnEl).addClass('open');
            openVariantGridItemDrawer($(btnEl).data('variant-id'));

          });

        }

      });

    });

  });

  $window.resize(function() {
    resize();
  });

  var resize = function () {

    var newGridSize = getGridSize();

    if (!gridSize || (gridSize && gridSize !== newGridSize)) {
      gridSize = newGridSize;
      closeOpenDrawers();
    }

  }

  resize();

};

mirai.variantGridLightbox = function () {

  var $variantGrids = $('.variant-grid')

  $variantGrids.find('.grid__image:not(.has-overlay)').fancybox({
    wrapCSS: 'product__image-wrapper',
    padding: 0,
    margin: 120, // Matches margin set in theme style
    nextEffect: 'fade',
    prevEffect: 'fade',
    minWidth: '80%',
    beforeLoad: function () {
      if ($(window).width() <= 991) return false
    }
  });

}

mirai.variantGridToggleSoldOut = function (productHandle) {

  if (true && productHandle) {

    var $body = $('body');

    if ($body.hasClass('template-product-variant-grid')) {

      var $variantGrid = $('.grid-flexbox.variant-grid'), $toggle = $('.product-variant-grid-toggle-sold-out');

      if ($variantGrid && $toggle) {

        var cookieName = 'smartdoll-' + productHandle + '-variant-grid-sold-out-visible';

        var cookieOptions = {
          expires: 500,
          path: '/',
          domain: window.location.hostname
        };

        var hideClass = 'sold-out-hide';

        function hide() {

          $variantGrid.find('.sold-out').addClass(hideClass);

          Cookies.remove(cookieName, cookieOptions);

        }

        function show() {

          $variantGrid.find('.sold-out').removeClass(hideClass);

          Cookies.set(cookieName, true, cookieOptions);

        }

        if (Cookies.get(cookieName)) show();

        $toggle.on('click', function (e) {

          e.preventDefault();

          var isVisible = Cookies.get(cookieName) || false;

          isVisible ? hide() : show();

          mirai.scrollToElement($variantGrid[0], 250, -80);

        });

      }

    }

  }

}

mirai.collectionToggleSoldOut = function (collectionHandle) {

  var $collectionSoldOutToggleBtns = $('.collection-sold-out-toggle-btn');

  var cookieName = 'smartdoll-' + collectionHandle + '-sold-out-visible';

  var cookieOptions = {
    expires: 500,
    path: '/',
    domain: window.location.hostname
  };

  var hideClass = 'sold-out-hide';

  var $grid = $('.grid .grid-flexbox');

  function hide() {

    $grid.find('.sold-out').addClass(hideClass);

    Cookies.remove(cookieName, cookieOptions);

  }

  function show() {

    $grid.find('.sold-out').removeClass(hideClass);

    Cookies.set(cookieName, true, cookieOptions);

  }

  if ($collectionSoldOutToggleBtns.length) {

    if (!Cookies.get(cookieName)) hide();

    $collectionSoldOutToggleBtns.each(function (index, btn) {

      var showLocalizedString = localize.buildString($(btn).data('show-text'));
      var hideLocalizedString = localize.buildString($(btn).data('hide-text'));

      if (!Cookies.get(cookieName)) {
        $(btn).html(showLocalizedString);
      } else {
        $(btn).html(hideLocalizedString);
      }

      $(btn).on('click', function (e) {

        e.preventDefault();

        var isVisible = Cookies.get(cookieName) || false;

        if (isVisible) {

          hide();

          $(btn).html(showLocalizedString);

        } else {

          show();

          $(btn).html(hideLocalizedString);

        }

      });

    });

  }

}

mirai.productArticle = function () {

  $('.product-article').find('.image-block .image a').fancybox({
    wrapCSS: 'product__image-wrapper',
    padding: 0,
    margin: 120, // Matches margin set in theme style
    nextEffect: 'fade',
    prevEffect: 'fade',
    minWidth: '80%',
    beforeLoad: function () {
      if ($(window).width() <= 991) return false
    }
  });

}

mirai.productArticleSidebar = function () {

  var toggleButton = function ($button) {

    $button.toggleClass('active');

    var $subMenu = $button.parentsUntil('li').parent().find('ul');

    $subMenu.toggleClass('collapsed');

  }

  $('.product-article-sidebar').find('button').on('click', function (e) {

    var $target = $(e.target);

    var $button = $target.closest('button');

    toggleButton($button);

    // The follow is to support opening / closing the same menus in a clone of the sidebar, such as collapsible-sticky-sidebar

    var buttonHash = $button.data('hash');

    if (buttonHash) {

      if ($button.parents("#collapsible-sticky-sidebar").length == 1) {
        toggleButton($('#collapsible-sticky-sidebar-cloned button[data-hash="' + buttonHash + '"]'));
      }

      if ($button.parents("#collapsible-sticky-sidebar-cloned").length == 1) {
        toggleButton($('#collapsible-sticky-sidebar button[data-hash="' + buttonHash + '"]'));
      }

      $('#collapsible-sticky-sidebar').trigger('recalculate')

    }

  })

}

mirai.randomiseGridItemImages = function () {

  $randomiseGridItems = $('.grid__image[data-randomise-images]');

  if ($randomiseGridItems.length) {

    $.each($randomiseGridItems, function (index, el) {

      if ($(el).data('randomise-images') && $(el).data('randomise-images') !== '') {

        var container = $(el).find('.randomise-images-image');

        var imageUrls = $(el).data('randomise-images').split('|');

        var randomIndex = Math.floor(Math.random() * imageUrls.length);

        container.empty();

        container.html('<img src="' + imageUrls[randomIndex] + '">').load();

      } else {

        $(el).find('.randomise-images-container').remove();

      }

    });

  }

}



// Display cart warning modals
mirai.cartWarningModal = function (type, okCallback) {

  var buildModal = function () {
    var build = [];

    if (type === 'two-or-more-dolls') {

      build.push('<div class="cart-warning__modal">');

      build.push('<h3>' + localize.buildString("Notice") + '</h3>');

      build.push('<p>' + localize.buildString("For first-time customers, please note that while you are welcome to order a doll along with accessories, we limit the purchase to one doll for the first order.  Returning customers may proceed with their orders as usual.") + '</p>');

      build.push('<button type="button" class="btn btn--full">' + localize.buildString("Roger that!") + '</button>');

      build.push('</div>');

    }

    return build.join('');
  };

  var showModal = function () {

    $.fancybox($(buildModal()), {
      wrapCSS: 'cart-warning__modal-wrapper',
      margin: 0,
      padding: 0,
      afterShow: function () {

        $('.cart-warning__modal-wrapper').find('button').click(function () {

          if (typeof okCallback === 'function') {
            okCallback();
          }

          $.fancybox.close();

        })

      }
    });

  };

  showModal();

};



Handlebars.registerHelper("resizeImage", function(src, size) {
  if (src == null) {
    return '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_medium_cropped.gif';
  }

  if (size == null) {
    return src;
  }

  if (size == 'master') {
    return src.replace(/http(s)?:/, "");
  }

  var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
  } else {
    return null;
  }
});

Handlebars.registerHelper("formatMoney", function(price) {
  return Shopify.formatMoney(price, Currency.moneyFormats['JPY'][Currency.format]);
});

// Initialize immediately
mirai.init();
